import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./Swipers.css";
import { Pagination } from "swiper/modules";
import Blush from "../../Images/Blush.jpg";
import Eyeliner from "../../Images/Eyeliner.jpg";
import Eyeshadow from "../../Images/Eyeshadow.jpg";
import Hair from "../../Images/Hairstyle.jpg";
import Lipstick from "../../Images/Lipstick.jpg";
import BlushHover from "../../Images/blushHover.jpg";
import EyelinerHover from "../../Images/eyelinerHover.jpg";
import EyeshadowHover from "../../Images/eyeshadowHover.jpg";
import HairHover from "../../Images/hairHover.jpg";
import LipstickHover from "../../Images/lipstickHover.jpg";
import { useNavigate } from "react-router-dom";

export default function SwiperCard() {
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const storedAccessToken = localStorage.getItem("AccessToken");
    if (storedAccessToken) setAccessToken(storedAccessToken);
  }, []);

  const navigate = useNavigate();

  return (
    <>
      <Swiper
        slidesPerView={3}
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 10 },
          480: { slidesPerView: 1, spaceBetween: 15 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
        modules={[Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="makeupImage">
            <img
              src={Hair}
              className="first-img"
              alt="Hair"
              loading="eager"
              decoding="sync"
            />
            <img
              src={HairHover}
              className="second-img"
              alt="Hair hover"
              loading="eager"
              decoding="sync"
            />
          </div>
          <div className="aboutImage">
            <h4>HAIR</h4>
            <button onClick={() => navigate(`/${accessToken}/hair`)}>
              TRY NOW
            </button>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="makeupImage">
            <img
              src={Eyeliner}
              className="first-img"
              alt="Eyeliner"
              loading="eager"
              decoding="sync"
            />
            <img
              src={EyelinerHover}
              className="second-img"
              alt="Eyeliner hover"
              loading="eager"
              decoding="sync"
            />
          </div>
          <div className="aboutImage">
            <h4>EYELINER</h4>
            <button onClick={() => navigate(`/${accessToken}/eyeliner`)}>
              TRY NOW
            </button>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="makeupImage">
            <img
              src={Lipstick}
              className="first-img"
              alt="Lipstick"
              loading="eager"
              decoding="sync"
            />
            <img
              src={LipstickHover}
              className="second-img"
              alt="Lipstick hover"
              loading="eager"
              decoding="sync"
            />
          </div>
          <div className="aboutImage">
            <h4>LIPSTICK</h4>
            <button onClick={() => navigate(`/${accessToken}/lipstick`)}>
              TRY NOW
            </button>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="makeupImage">
            <img
              src={Blush}
              className="first-img"
              alt="Blush"
              loading="eager"
              decoding="sync"
            />
            <img
              src={BlushHover}
              className="second-img"
              alt="Blush hover"
              loading="eager"
              decoding="sync"
            />
          </div>
          <div className="aboutImage">
            <h4>BLUSH</h4>
            <button onClick={() => navigate(`/${accessToken}/blush`)}>
              TRY NOW
            </button>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="makeupImage">
            <img
              src={Eyeshadow}
              className="first-img"
              alt="Eyeshadow"
              loading="eager"
              decoding="sync"
            />
            <img
              src={EyeshadowHover}
              className="second-img"
              alt="Eyeshadow hover"
              loading="eager"
              decoding="sync"
            />
          </div>
          <div className="aboutImage">
            <h4>EYESHADOW</h4>
            <button onClick={() => navigate(`/${accessToken}/eyeshadow`)}>
              TRY NOW
            </button>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
}
